<span class="fa-stack toro-asset-type-icon-container" [pTooltip]="typeTip" tooltipPosition="top">
    <i *ngIf="!isUnknown" class="fa-stack-1x toro-asset-type-icon" [ngClass]="baseIconClass" [ngStyle]="{'color': color}"></i>
    <i *ngIf="!isUnknown" class="fa-stack-1x toro-asset-type-icon" [ngClass]="outlineIconClass" [ngStyle]="{'color': outlineColor}"></i>
    <fa-icon *ngIf="isUnknown" icon="map-marker-alt"></fa-icon>
</span>
